import React, { useState, useEffect } from 'react';
import { 
  Chart as ChartJS, 
  CategoryScale, 
  LinearScale, 
  BarElement, 
  LineElement,
  PointElement,
  Title, 
  Tooltip, 
  Legend 
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import axios from 'axios';
import '../styles/SalesCharts.css';

// Registrar componentes de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const AdminYearlySalesChart = ({ selectedPOS }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchYearlySalesData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        let url = '/api/admin-stats/yearly-sales-chart';
        if (selectedPOS && selectedPOS !== 'all') {
          url += `?pointOfSaleId=${selectedPOS}`;
        }
        
        console.log('Obteniendo datos de ventas anuales desde:', url);
        
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        setChartData(response.data);
        setError(null);
      } catch (error) {
        console.error('Error al obtener datos de ventas anuales:', error);
        
        // Crear datos vacíos para el año actual
        const currentYear = new Date().getFullYear();
        
        // Crear etiquetas para cada mes
        const months = [
          'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];
        
        // Crear arrays de datos vacíos
        const monthlyTotals = Array(12).fill(0);
        const cumulativeTotals = Array(12).fill(0);
        
        // Crear datos de gráfica vacíos
        const emptyChartData = {
          labels: months,
          year: currentYear,
          monthlyData: {
            totals: monthlyTotals
          },
          cumulativeData: {
            totals: cumulativeTotals
          }
        };
        
        setChartData(emptyChartData);
        setError(null);
      } finally {
        setLoading(false);
      }
    };

    fetchYearlySalesData();
  }, [selectedPOS]);

  if (loading) {
    return <div className="charts-loading">Cargando gráfica de ventas anuales...</div>;
  }

  if (!chartData) {
    return <div className="charts-empty"></div>;
  }

  // Configuración para la gráfica de barras (ventas mensuales)
  const barChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: `Ventas Mensuales ${chartData.year}`,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return '$' + value.toFixed(2);
          }
        }
      }
    }
  };

  const barChartData = {
    labels: chartData.labels,
    datasets: [
      {
        label: 'Ventas Mensuales',
        data: chartData.monthlyData.totals,
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  };

  return (
    <div className="chart-wrapper">
      <h3>Ventas Mensuales (Enero a Diciembre)</h3>
      <div className="chart-container">
        <Bar options={barChartOptions} data={barChartData} />
      </div>
    </div>
  );
};

export default AdminYearlySalesChart;
